import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'hc-busy-indicator',
    templateUrl: './busy-indicator.component.html',
    styleUrls: ['./busy-indicator.component.scss']
})
export class BusyIndicatorComponent implements OnInit {
    constructor() {
    }

    ngOnInit() {
    }
}
